import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { MapPin, Truck, CalendarDays, Building2, LogOut, LayoutDashboard, Sparkles } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashPath =
    user?.role === "owner" ? "/dashboard/owner" :
    user?.role === "organizer" ? "/dashboard/organizer" :
    user?.role === "admin" ? "/dashboard/admin" : "/explore";

  return (
    <header className="sticky top-0 z-50 gr-glass border-b border-teal-900/5">
      <nav className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/flavorflow-logo.png" alt="FlavorFlow" className="h-8 sm:h-9 w-auto object-contain" />
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <NavLink to="/explore" icon={<MapPin className="w-4 h-4" />} label="Live Map" testid="nav-explore" />
          <NavLink to="/concierge" icon={<Sparkles className="w-4 h-4" />} label="Ask AI" testid="nav-concierge" />
          <NavLink to="/events" icon={<CalendarDays className="w-4 h-4" />} label="Events" testid="nav-events" />
          <NavLink to="/corporate" icon={<Building2 className="w-4 h-4" />} label="Corporate" testid="nav-corporate" />
          <NavLink to="/pricing" icon={<Truck className="w-4 h-4" />} label="For Trucks" testid="nav-pricing" />
        </div>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                className="rounded-full font-semibold hidden sm:flex"
                onClick={() => navigate(dashPath)}
                data-testid="nav-dashboard-btn"
              >
                <LayoutDashboard className="w-4 h-4 mr-1" /> Dashboard
              </Button>
              <Button
                variant="ghost"
                className="rounded-full"
                onClick={() => { logout(); navigate("/"); }}
                data-testid="nav-logout-btn"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="rounded-full font-semibold" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Log in
              </Button>
              <Button
                className="rounded-full font-semibold bg-[#0FB5A6] hover:bg-[#0E9E92] text-white active:scale-95 transition-transform"
                onClick={() => navigate("/register")}
                data-testid="nav-signup-btn"
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

const NavLink = ({ to, icon, label, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-semibold text-slate-600 hover:text-[#0FB5A6] hover:bg-teal-50 transition-colors"
  >
    {icon} {label}
  </Link>
);
